import React, { FC, Suspense } from 'react';
import { StateContext } from './contexts/state-context';
import { CollectionsContextProvider } from './contexts/providers/collection';
import { AppMarketContent } from './AppContent';
import styles from './App.module.scss';
import { AppConfig } from './models/app';
import { setupStore } from './redux/configureStore';
import { webPortalLogoutBridge } from './redux/api/appMarket-api-slice';
import { Provider } from 'react-redux';
import { RatingsAndReviewsProvider } from './contexts/providers/ratings-reviews';
import { CoreDispatchesContext, defaultDispatches } from './contexts/dispatches';
import { CoreAppDispatches } from './redux/core-app-state/types';
import { PermissionsProvider } from './contexts/providers/permissions';
import { MerchantContextProvider } from './contexts/providers/merchant';
import { BillingContextProvider } from './contexts/providers/billingInfo';
import { BackgroundShimmer } from 'components/Shimmer';

type ComponentProps = {
  appConfig?: AppConfig;
  dispatches?: CoreAppDispatches;
};

const store = setupStore();

export const App: FC<ComponentProps> = props => {
  const { appConfig, dispatches } = props;

  if (dispatches?.logout) {
    webPortalLogoutBridge(dispatches.logout);
  }

  return (
    <div className={styles.wrapper}>
      <Provider store={store}>
        <Suspense fallback={<BackgroundShimmer smallShimmer={false} />}>
          <CoreDispatchesContext.Provider value={dispatches || defaultDispatches}>
            <StateContext.Provider
              value={{ state: { context: appConfig?.context, account: appConfig?.account } }}
            >
              <MerchantContextProvider>
                <PermissionsProvider>
                  <RatingsAndReviewsProvider>
                    <BillingContextProvider>
                      <CollectionsContextProvider>
                        <AppMarketContent />
                      </CollectionsContextProvider>
                    </BillingContextProvider>
                  </RatingsAndReviewsProvider>
                </PermissionsProvider>
              </MerchantContextProvider>
            </StateContext.Provider>
          </CoreDispatchesContext.Provider>
        </Suspense>
      </Provider>
    </div>
  );
};

export default App;
